import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { defs } from 'src/app/defs';
import { env } from '../../../environments/environment';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private log: NGXLogger) { }
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		const token = localStorage.getItem(defs.authToken);
		const activationToken = localStorage.getItem(defs.activationToken);
		const setHeaders = { Accept: defs.contentType,
									'Content-Type': defs.contentType}

		if (token && !request.url.startsWith(`${env.beURL}/login`)) {
			setHeaders['Authorization'] = `Bearer ${token}`
		} else if (activationToken && request.url.startsWith(`${env.beURL}/reg/activate`)) {
			setHeaders['Authorization'] = `Bearer ${activationToken}`
		}
		const clone = request.clone({setHeaders})
		this.log.debug('AuthInterceptor:', clone)
		return next.handle(clone);
	}
}
